import { Box, Button, Grid } from "@material-ui/core";
import { PessoaPostModel } from "model/api/gestao/pessoa/pessoa-post-model";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CircularLoading } from "views/components";
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus";
import { AtualizarIcon, SalvarIcon } from "views/components/icons";
import { useThemeQueries } from "views/theme";
import { useStyles } from "./accordion-cliente-parametros-styles";
import { SelectSaurus } from "views/components/controles/selects/select-saurus/select-saurus";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { ParametroModel } from "model/api/gestao/parametro/parametro-model";
import { ParametroOpcaoModel } from "model/api/gestao/parametro/parametro-opcao-model";
import { useGetParametros } from "data/api/gestao/parametro/get-parametro";
import { useGetParametrosOpcoes } from "data/api/gestao/parametro/get-parametro-opcao";
import { KeyValueModel } from "model";
import { useGetPessoaParametroList } from "data/api/gestao/pessoa-parametro/get-pessoa-parametro-list";
import { PessoaParametroResponseModel } from "model/api/gestao/pessoa/pessoa-parametro-response-model";
import { usePostPessoaParametro } from "data/api/gestao/pessoa-parametro/post-pessoa-parametro";
import { usePutPessoaParametro } from "data/api/gestao/pessoa-parametro/put-pessoa-parametro";
import { PessoaParametroRequestModel } from "model/api/gestao/pessoa/pessoa-parametro-request-model";
import { useToastSaurus } from "services/app";
import { DialogSaurus } from "views/components/dialog/dialog-saurus/dialog-saurus";
import { ListIcon } from "views/components/icons/list-icon";
import { isEmpty } from "lodash";
import { CardParametroOpcao } from "views/components/cards/card-parametro-opcao/card-parametro-opcao";
import { usePostParametroVisualizacao } from "data/api/gestao/parametro/post-parametro-visualizacao";
import { ParametroVisualizacaoRequestModel } from "model/api/gestao/parametro/parametro-visualizacao-request-model";
import { DicionarioIcon } from "views/components/icons/dicionario-icon";

type Props = {
    cliente: PessoaPostModel;
    carregando: boolean
}

export const AccordionClienteParametros = ({ cliente, ...props }: Props) => {
    const { theme } = useThemeQueries()
    const [openAccordion, setOpenAccordion] = useState<boolean>(false)
    const { carregando: carregandoGetParametros, getParametros } = useGetParametros();
    const { carregando: carregandoGetParametrosOpcoes, getParametroOpcoes } = useGetParametrosOpcoes();
    const { carregando: carregandoGetPessoaParametros, getPessoaParametroList } = useGetPessoaParametroList();
    const { carregando: carregandoPostPessoaParametros, postPessoaParametro } = usePostPessoaParametro();
    const { carregando: carregandoPutPessoaParametros, putPessoaParametro } = usePutPessoaParametro();
    const { carregando: carregandoPostParametroVisualizacao, postParametroVisualizacao } = usePostParametroVisualizacao();
    const iframeRef = useRef(null);

    const classes = useStyles()
    const { showToast } = useToastSaurus()

    const [parametroSelecionado, setParametroSelecionado] = useState<ParametroModel | undefined>(undefined);
    const [parametros, setParametros] = useState<ParametroModel[] | undefined>(undefined);
    const [parametroOpcoes, setParametroOpcoes] = useState<ParametroOpcaoModel[] | undefined>();
    const [carregandoInterno, setCarregandoInterno] = useState<boolean>(false)
    const [valorAtual, setValorAtual] = useState<string>('')
    const [dialogOpcoesAberto, setDialogOpcoesAberto] = useState<boolean>(false)
    const [dialogDicionarioAberto, setDialogDicionarioAberto] = useState<boolean>(false)
    const [exibirImpressaoHtml, setExibirImpressaoHtml] = useState<boolean>(false)
    const [pessoaParametro, setPessoaParametro] = useState<PessoaParametroResponseModel | undefined>(undefined);

    const carregando = carregandoInterno || carregandoGetParametros ||
        carregandoGetParametrosOpcoes || carregandoGetPessoaParametros ||
        carregandoPostPessoaParametros || carregandoPutPessoaParametros || carregandoPostParametroVisualizacao ||
        props.carregando;


    const preencherIframe = useCallback((html: string) => {
        if (iframeRef.current) {
            const customCSS = `
                <style>
                    .folha {
                        background: #f5f1e5;
                        font-family: 'Courier New, Courier, monospace';
                        border: 1px solid #333;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                    }
                    hr {
                        color: #FFF;
                        background: #333;
                        border: 1px solid #333;
                        margin: 0px;
                    }
                    hr:after {
                        line-height:30px;
                        content: '<GUILHOTINA>';
                        color: #ffffff;
                    }
                </style>
                `;
            const doc = (iframeRef.current as any).contentDocument || (iframeRef.current as any).contentWindow.document;
            doc.open();
            doc.write(`<center><div class="folha">${html}${customCSS}`);
            doc.close();
        }
    }, [])

    const preencherImpressaoHtml = useCallback(async (id: string, modelo: string) => {
        var ret = await postParametroVisualizacao(new ParametroVisualizacaoRequestModel(id, modelo));
        if (ret.erro) {
            showToast("error", ret.erro.message || "Erro ao gerar visualização do parâmetro.");
            preencherIframe('');
            setExibirImpressaoHtml(false);
            return;
        }
        setExibirImpressaoHtml(!isEmpty(ret.resultado?.data?.html));
        preencherIframe(ret.resultado?.data?.html || '');
    }, [postParametroVisualizacao, preencherIframe, showToast]);

    const preencherParametroSelecionado = useCallback(async (parametro: ParametroModel) => {
        if (!parametro) return;

        setCarregandoInterno(true);
        try {
            //BUSCA AS OPCOES
            const response = await getParametroOpcoes(parametro.id);
            var opcoes = response.resultado?.data || [];
            setParametroOpcoes(opcoes);

            //BUSCA O PARAMTERO DA PESSOA
            const responsePessoa = await getPessoaParametroList(cliente.id, parametro.id);
            if (responsePessoa.resultado?.data && responsePessoa.resultado.data.length > 0) {
                const pessoaParametroData = responsePessoa.resultado.data[0];
                setPessoaParametro(pessoaParametroData);
                setValorAtual(pessoaParametroData.valor || '');
                preencherImpressaoHtml(parametro.id, pessoaParametroData.valor || '');

            } else {
                setPessoaParametro(new PessoaParametroResponseModel(null, cliente.id, parametro.id, '', '', false));
                setValorAtual(opcoes?.find(opcao => opcao.padrao)?.valor || '');
                preencherImpressaoHtml(parametro.id, opcoes?.find(opcao => opcao.padrao)?.valor || '');
            }
        } catch (error) {
            console.error("Erro ao buscar opções do parâmetro:", error);
        }
        setCarregandoInterno(false);

    }, [cliente.id, getParametroOpcoes, getPessoaParametroList, preencherImpressaoHtml]);


    const selecionarParametro = useCallback((model: ParametroModel) => {
        setParametroSelecionado((prev) => {
            if (prev && prev.id === model.id) return prev;

            preencherParametroSelecionado(model);
            return model;
        });

    }, [preencherParametroSelecionado]);

    const preencherParametros = useCallback(async () => {
        try {
            const response = await getParametros();
            const data = response.resultado?.data?.list || [];
            setParametros(data);

            if (data.length > 0) {
                selecionarParametro(data[0]);
            }

        } catch (error) {
            console.error("Erro ao buscar parâmetros:", error);
        }
    }, [getParametros, selecionarParametro]);

    useEffect(() => {
        if (!parametros && openAccordion)
            preencherParametros();
    }, [openAccordion, parametros, preencherParametros]);

    const handleSalvar = useCallback(async () => {
        try {
            setCarregandoInterno(true);

            if (pessoaParametro?.id) {
                const env = await putPessoaParametro(new PessoaParametroRequestModel(pessoaParametro?.id, pessoaParametro?.pessoaId, pessoaParametro?.parametroId, valorAtual));
                if (env.erro)
                    if (env.erro) throw env.erro;


            } else {
                const env = await postPessoaParametro(new PessoaParametroRequestModel(pessoaParametro!.id!, pessoaParametro?.pessoaId, pessoaParametro?.parametroId, valorAtual));
                if (env.erro)
                    if (env.erro) throw env.erro;

            }

            preencherParametroSelecionado(parametroSelecionado!);
            showToast("success", "Parâmetro atualizado com sucesso!");
        }
        catch (error: any) {
            showToast("error", error.message || "Erro ao salvar parâmetro.");
        }
        finally {
            setCarregandoInterno(false)
        }
    }, [parametroSelecionado, pessoaParametro, postPessoaParametro, preencherParametroSelecionado, putPessoaParametro, showToast, valorAtual])

    const dialogOpcoes = useMemo(() => {
        return <DialogSaurus
            icone={
                <ListIcon tipo="BUTTON" fill={`${theme.palette.primary.main}`} />
            }
            isButtonTitleClose
            handleClickClose={() => { setDialogOpcoesAberto(false); }}
            aberto={dialogOpcoesAberto || false}
            titulo="Opções de Parâmetro"
            tamanho="xs"
        >
            <Box className={classes.dialogContainer}>
                <Box className={classes.dialogContent}>
                    <Grid
                        container
                        direction="column"
                        style={{ marginBottom: 8 }}
                    >
                        {parametroOpcoes?.map((opcao) => (
                            <CardParametroOpcao model={opcao} onClick={(model) => {
                                setCarregandoInterno(true);
                                setValorAtual(model.valor || '');
                                preencherImpressaoHtml(parametroSelecionado?.id || '', model.valor || '');
                                setDialogOpcoesAberto(false);
                                setCarregandoInterno(false);
                            }}></CardParametroOpcao>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </DialogSaurus>
    }, [classes.dialogContainer, classes.dialogContent, dialogOpcoesAberto, parametroOpcoes, parametroSelecionado?.id, preencherImpressaoHtml, theme.palette.primary.main]);

    const dialogDicionario = useMemo(() => {
        return <DialogSaurus
            icone={
                <DicionarioIcon tipo="BUTTON" fill={`${theme.palette.primary.main}`} />
            }
            isButtonTitleClose
            handleClickClose={() => { setDialogDicionarioAberto(false); }}
            aberto={dialogDicionarioAberto || false}
            titulo="Dicionário de Dados"
            tamanho="md"
        >
            <Box className={classes.dialogContainer}>
                <Box className={classes.dialogContent}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <Grid
                            container
                            direction="column"
                            style={{ marginBottom: 8 }}
                        >
                            <pre style={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                color: theme.palette.primary.main,
                                fontFamily: 'Courier New, Courier, monospace', fontSize: 14, padding: 8
                            }}>
                                {parametroSelecionado?.dicionario}
                            </pre>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </DialogSaurus>
    }, [classes.dialogContainer, classes.dialogContent, dialogDicionarioAberto, parametroSelecionado?.dicionario, theme.palette.primary.main]);

    const content = useMemo(() => {
        return <Grid container spacing={1} style={{
            position: 'relative'
        }}>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={12} justifyContent="flex-end">
                        <SelectSaurus
                            disabled={carregando}
                            allowSubmit={false}
                            label="Parâmetro"
                            fullWidth
                            conteudo={(parametros || []).map((item) => new KeyValueModel(item.id, item.nome))}
                            autoComplete={'off'}
                            value={parametroSelecionado?.id || ''}
                            onChange={ev => {
                                const item = (parametros || [])
                                    .filter(item => ev.target.value === item.id);
                                selecionarParametro(item[0]);
                            }} />
                    </Grid>
                    <Grid container item xs={12} md={12} lg={exibirImpressaoHtml ? 6 : 12} style={{ marginTop: 8 }}>
                        <Grid xs={12} item>
                            <TextFieldSaurus
                                disabled={carregando}
                                allowSubmit={false}
                                label="Template"
                                fullWidth
                                tipo="TEXTO"
                                multiline
                                rows={28}
                                autoComplete={'off'}
                                value={valorAtual}
                                onChange={ev => {
                                    setValorAtual(ev.target.value)
                                }}
                            />
                        </Grid>
                        <Box gridGap={8} mt={1} display="flex" width="100%" flexDirection="row" >
                            {parametroOpcoes && parametroOpcoes.length > 0 && (
                                <Button variant="contained" color='secondary' onClick={() => {
                                    setDialogOpcoesAberto(true);
                                }} fullWidth>
                                    <ListIcon tipo='BUTTON' />
                                    Opções
                                </Button>
                            )}
                            {!isEmpty(parametroSelecionado?.dicionario) && (
                                <Button variant="contained" color='secondary' onClick={() => {
                                    setDialogDicionarioAberto(true);
                                }} fullWidth>
                                    <DicionarioIcon tipo='BUTTON' />
                                    Dicionário
                                </Button>
                            )}
                        </Box>
                    </Grid>
                    {exibirImpressaoHtml && (
                        <Grid container style={{ width: 300, marginTop: 8 }} item xs={12} md={12} lg={6}>
                            <Grid xs={12} item>
                                <div className={classes.txtFakeContainer}>
                                    <span className={classes.txtFakeContainerTitle}>Exemplo de Impressão</span>
                                    <div className={classes.txtFakeContent}>
                                        <iframe
                                            ref={iframeRef}
                                            title="Exemplo de Impressão"
                                            style={{ width: "100%", height: "500px", border: "none" }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                            <Grid xs={12} item style={{ marginTop: 8 }}>
                                <Button variant="contained" color='secondary' onClick={() => preencherImpressaoHtml(parametroSelecionado?.id || '', valorAtual)} fullWidth>
                                    <AtualizarIcon tipo='BUTTON' />
                                    Visualizar
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={12} container justifyContent="flex-end" style={{ marginTop: 8 }}>
                        <Button variant="contained" color='primary' size="large" onClick={handleSalvar} fullWidth>
                            <SalvarIcon tipo='BUTTON_PRIMARY' />
                            Salvar Parâmetro
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    }, [carregando, classes.txtFakeContainer, classes.txtFakeContainerTitle, classes.txtFakeContent, exibirImpressaoHtml, handleSalvar, parametroOpcoes, parametroSelecionado?.dicionario, parametroSelecionado?.id, parametros, preencherImpressaoHtml, selecionarParametro, valorAtual]
    );
    return (
        <>
            <AccordionSaurus
                labelPrimary="Parâmetros do Cliente"
                tipoExpand="bold"
                noPaperRoot={false}
                heightDivider={2}
                showDivider={openAccordion}
                colorDivider={theme.palette.primary.main}
                colorExpand={theme.palette.primary.main}
                expanded={openAccordion}
                onChange={() => setOpenAccordion(prev => !prev)}
            >
                {content}
            </AccordionSaurus >
            {dialogOpcoes}
            {dialogDicionario}
        </>
    );
};
